import { Link as MuiLink, Stack } from '@mui/material';
import { Link, useNavigate } from '@tanstack/react-router';

import { useAuthTranslation } from '../i18n/auth-i18n';
import { AUTH_PATHS } from '../lib/auth-paths';
import { AuthLayout } from './AuthLayout';
import { EmailPasswordForm } from './EmailPasswordForm';

export interface SignUpPageProps {
  logo: React.ReactElement;
  brandingSubtitle: string;
}

const LINK_SX = {
  color: 'text.primary',
  fontWeight: 600,
  textDecorationColor: 'transparent',
  transition: 'color 160ms ease, text-decoration-color 160ms ease',
  '@media (hover: hover)': { '&:hover': { textDecorationColor: 'currentColor' } },
} as const;

export function SignUpPage({ logo, brandingSubtitle }: SignUpPageProps) {
  const { t } = useAuthTranslation();
  const navigate = useNavigate();

  return (
    <AuthLayout logo={logo} brandingSubtitle={brandingSubtitle} data-testid="auth.signup-page">
      <EmailPasswordForm
        mode="signup"
        onSuccess={(email) => navigate({ to: AUTH_PATHS.verifyEmail, search: { email } })}
      />
      <Stack spacing={1} alignItems="center" sx={{ mt: 3 }}>
        <MuiLink component={Link} to={AUTH_PATHS.login} variant="body2" underline="hover" sx={LINK_SX}>
          {t('auth.signup.haveAccount')}
        </MuiLink>
      </Stack>
    </AuthLayout>
  );
}
